import React, {Fragment, useState, useEffect} from 'react';
import Breadcrumb from '../common/breadcrumb';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import CKEditors from "react-ckeditor-component";
import 'react-dropzone-uploader/dist/styles.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SelectFetch from '../common/select_fetch';
import Elemts from '../common/elemts/elemts3';

const PublicacionesEditar = (props) => {

	const [id] = useState(props.match.params.id);
	const [ready, setReady] = useState(false);
	const [elemts, setElemts] = useState([]);
	const [publicacion, setPublicacion] = useState({});
	const [contenido_html, setContenido_html] = useState('');

	useEffect(() => {
		const recuperar=()=>{
			fetch('/z_publicaciones', {
				method: 'POST',
				body: JSON.stringify({ID: id}),
				headers: {'Content-Type': 'application/json'}
			})
			.then(res => res.json())
			.then(res => {
				console.log(res);
				
				if(res.status === 'OK'){
					setPublicacion(res.result[0][0])
					setContenido_html(res.result[0][0].CONTENIDO)
	
					var vid=[]
					for (var x=0;x<res.result[1].length;x++) {
						vid.push({data:{ key:0, title:res.result[1][x].TIPO_VIDEO, link:res.result[1][x].URL, code:res.result[1][x].CODE }, key:0, order:x, title:"Video"})
					}
					setElemts(vid)
				}else{
					console.log('Error interno');
				}
				setReady(true)
			})
			.catch(err => {
				console.log('Error: '+err);
			})
		}
		recuperar();
		// eslint-disable-next-line
	}, []);

	const set = (name, value) => name === 'elemts' && setElemts([...value])

	const saveButton=()=>{
		let form_data = new FormData(document.getElementById('form_publicaciones'))
		var datosVideo=[]
		for(var i=0;i<elemts.length;i++){
			if(elemts[i].title==="Video" && elemts[i].data.link ){
				var texto_link=elemts[i].data.link
				if(texto_link.trim()!==''){
					let title=elemts[i].data.title
					let link=elemts[i].data.link
					let code=elemts[i].data.code
					datosVideo.push({title,link,code})
				}
				
			}
		}

		form_data.append('ID', id)
		form_data.append('IMAGEN', publicacion.IMAGEN)
		form_data.append('AUTOR', localStorage.getItem('id_usr'))
		form_data.append('CONTENIDO', contenido_html)
		form_data.append('datosVideo', JSON.stringify(datosVideo))

		fetch('/p_publicaciones', {
			method: 'PUT',
			body: form_data
		})
		.then(res => res.json())
		.then(res => {
			if(res.status === 'OK' && res.rows[0] > 0){
				document.getElementById('form_publicaciones').reset()
				toast.success("Agregado correctamente", { position: toast.POSITION.BOTTOM_RIGHT })
				console.log('Agregado');
			}
			else{
				console.log('No se pudo agregar');
			}
		})
		.catch(err => {console.log('Error: '+err);})
	}

	const backButton = ()=> {
		props.history.push('/publicaciones')
	}

	const editorData=(event)=>{
		setContenido_html(event.editor.getData())
	}

	return (
		<Fragment>
			<Breadcrumb title="Crear publicación" parent="Publicaciones" />
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12">
						<form id="form_publicaciones" className="form theme-form">
							<div className="card">
								<div className="card-header">
									<h5>Información de la publicación</h5>
								</div>
								{
								ready ?
								<div className="card-body add-post">
										<div className="col-sm-12">
											<div className="form-group">
												<label htmlFor="form_titulo">Título:</label>
												<input className="form-control" id="form_titulo" name="TITULO" type="text" placeholder="Título del publicación" defaultValue={publicacion.TITULO} required="" />
											</div>
											<div className="form-group">
												<label htmlFor="form_etiquetas">Etiquetas:</label>
												<input className="form-control" id="form_etiquetas" name="ETIQUETAS" type="text" placeholder="Título secundario" defaultValue={publicacion.ETIQUETAS} required="" />
											</div>
											<div className="form-group">
												<label htmlFor="form_fuente">Fuente:</label>
												<input className="form-control" id="form_fuente" name="FUENTE" type="text" placeholder="Fuente(s) de información" defaultValue={publicacion.FUENTE} required="" />
											</div>
											<SelectFetch 
												element_id='form_categoria'
												element_name='CATEGORIA'
												label_text='Categoría'
												default_selected={publicacion.ID_CATEGORIA}
												fetch_route='/p_categorias'
											/>
											<div className="form-group">
												<label className="form-label">Imagen de la publicación:</label>
												<input id="form_imagen" name="IMAGEN" className="form-control" type="file" accept=".png,.jpg"/>
											</div>
											<div className="form-group">
												<label className="form-label">Contenido:</label>
												<CKEditors
												config={{
													versionCheck: false,
													allowedContent: true,
													height: 400
												}}
												content={contenido_html}
												activeclassName="p10"
												events={{
													"change": editorData
												}}
												/>
											</div>
											<Elemts noticia={elemts} set={set} editable={true}/>
										</div>
								</div>
								: 
								<div className="card-body d-flex justify-content-center align-items-center">
									<div className="loader-box mr-4">
										<div className="loader">
											<div className="line bg-warning"></div>
											<div className="line bg-warning"></div>
											<div className="line bg-warning"></div>
											<div className="line bg-warning"></div>
										</div>
									</div>
									<h5 className="text-uppercase">Cargando...</h5>
								</div>
								}
								<div className="card-footer">
									<div className="row">
										<div className="col-12">
											<div className="btn-showcase">
												<button onClick={saveButton} className="btn btn-primary mr-1" type="button">Guardar</button>
												<button onClick={backButton} className="btn btn-light txt-dark">Atrás</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</Fragment>
	);
}
 
export default PublicacionesEditar;